"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketStatsAttribute$ = exports.MarketStatsAttribute$outboundSchema = exports.MarketStatsAttribute$inboundSchema = void 0;
exports.marketStatsAttributeToJSON = marketStatsAttributeToJSON;
exports.marketStatsAttributeFromJSON = marketStatsAttributeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.MarketStatsAttribute$inboundSchema = z.object({
    average_days_on_market: z.nullable(z.number()),
    percentage_market_share: z.nullable(z.number()),
    percentage_of_asking_price_achieved: z.nullable(z.number()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_days_on_market": "averageDaysOnMarket",
        "percentage_market_share": "percentageMarketShare",
        "percentage_of_asking_price_achieved": "percentageOfAskingPriceAchieved",
    });
});
/** @internal */
exports.MarketStatsAttribute$outboundSchema = z.object({
    averageDaysOnMarket: z.nullable(z.number()),
    percentageMarketShare: z.nullable(z.number()),
    percentageOfAskingPriceAchieved: z.nullable(z.number()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageDaysOnMarket: "average_days_on_market",
        percentageMarketShare: "percentage_market_share",
        percentageOfAskingPriceAchieved: "percentage_of_asking_price_achieved",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MarketStatsAttribute$;
(function (MarketStatsAttribute$) {
    /** @deprecated use `MarketStatsAttribute$inboundSchema` instead. */
    MarketStatsAttribute$.inboundSchema = exports.MarketStatsAttribute$inboundSchema;
    /** @deprecated use `MarketStatsAttribute$outboundSchema` instead. */
    MarketStatsAttribute$.outboundSchema = exports.MarketStatsAttribute$outboundSchema;
})(MarketStatsAttribute$ || (exports.MarketStatsAttribute$ = MarketStatsAttribute$ = {}));
function marketStatsAttributeToJSON(marketStatsAttribute) {
    return JSON.stringify(exports.MarketStatsAttribute$outboundSchema.parse(marketStatsAttribute));
}
function marketStatsAttributeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MarketStatsAttribute$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MarketStatsAttribute' from JSON`);
}
//# sourceMappingURL=marketstatsattribute.js.map